$( document ).ready(function() {
    if ($('.sticky-atc').length > 0) {
    $('.sticky-atc').append(`
        <div class="sticky-block">
            <button type="button" class="btn btn--primary btn--add-to-cart btn--addtocart_animation">
                <span class="btn__text">
                    <span class="material-icons-outlined button-cart-icon">shopping_cart</span>
                    <span class="btn__add-to-cart-text">Add to Cart</span>
                </span>
            </button>
        </div>
    `);
    $('.sticky-block').append($('.fire-img').clone());

    $('.sticky-block .btn--add-to-cart').click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('.product-single__form').offset().top
        }, 1500);
    });

    setInterval(function() {
        const buttonAnimation = $('.btn--addtocart_animation');
        buttonAnimation.addClass('animated pulse');
        setTimeout(() => {
            buttonAnimation.removeClass('animated pulse');
        }, 1000);
    }, 5000);

    function updateStickyButton() {
        var button = $('form .product-single__add-to-cart');
        var buttonOffset  = button.offset().top;
        var buttonHeight = button.outerHeight(true);
        var buffer = 10;
        var stickyBlock = $('.sticky-block');
        var currentScroll = $(this).scrollTop();
        var windowHeight = jQuery(this).height();

        if ((currentScroll + buffer > buttonOffset + buttonHeight) || (currentScroll + windowHeight - buffer < buttonOffset)) {
            if (stickyBlock.hasClass('hide')) {
                stickyBlock.removeClass('hide');
            }
        } else {
            if (!stickyBlock.hasClass('hide')) {
                stickyBlock.addClass('hide');
            }
        }
    }

    $(window).on('scroll resize', function () {
        updateStickyButton();
    });

    updateStickyButton();
  }
});
